/* eslint-disable indent */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  SiCplusplus,
  SiFramer,
  SiGithub,
  SiNeovim,
  SiNextdotjs,
  SiReact,
  SiRust,
  SiFireship,
  SiTailwindcss,
  SiTypescript,
  SiWebgl,
  SiZig,
} from "react-icons/si";
import { IconType } from "react-icons";

export type ProjectProps = {
  id: number;
  name: string;
  description: string;
  descriptionS: string;
  technologies: IconType[];
  techNames: string[];
  techLinks: string[];
  github: string;
  demo: string;
  image: string;
  available: boolean;
};

export const projects = [
  {
    id: 0,
    name: "100k Mcap",
    description: "Dex Update (DONE!)",
    descriptionS: "Burn Time for $Grenie Creator Rewards",
    technologies: [],
    techNames: ["0x52 Based Pepe"],
    techLinks: [""],
    github: "",
    demo: "",
    image: "/dexp.png",
    available: true,
  },
  {
    id: 2,
    name: "200k Mcap",
    description: "BasedPepe Airdrop for holders",
    descriptionS: "Burn Time for $Grenie Creator Rewards",
    technologies: [],
    techNames: ["Brett"],
    techLinks: [""],
    github: "",
    demo: "",
    image: "/basedpepe.png",
    available: true,
  },
  {
    id: 4,
    name: "400k Mcap",
    description: "Brett Airdrop for holders",
    descriptionS: "Burn Time for $Grenie Creator Rewards",
    technologies: [],
    techNames: ["Brett"],
    techLinks: [""],
    github: "",
    demo: "",
    image: "/bbrett.png",
    available: true,
  },
  {
    id: 6,
    name: "500k Mcap",
    description: "$Grenie Airdrop for holders",
    descriptionS: "Burn Time for $Grenie Creator Rewards",
    technologies: [],
    techNames: ["Brett"],
    techLinks: [""],
    github: "",
    demo: "",
    image: "/grenie.png",
    available: true,
  },
  {
    id: 8,
    name: "1M Mcap",
    description: "Only Burn Just Burn All Burn Burn Burn Burn",
    descriptionS: "Burn Time for $Grenie Creator Rewards",
    technologies: [],
    techNames: ["Brett"],
    techLinks: [""],
    github: "",
    demo: "",
    image: "/burning.png",
    available: true,
  },
];
